import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getApiErrorMessage } from "src/types/api";

export interface GeneColumnListParams {
    columns: string[];
}

export interface iGeneColumnListState {
    isLoading: boolean;
    message: string | null;
    response: GeneColumnListParams | null;  // 배열 아니고 단일 객체
}

const initialState: iGeneColumnListState = {
    isLoading: false,
    message: "",
    response: null,
};

export const getGeneColumnListAPI = createAsyncThunk<GeneColumnListParams,void,{ rejectValue: string }>(
    "GET_GENE_COLUMN_LIST",
    async (_, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/tools/gene-expression-column-list/';

            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });

            return response.data as GeneColumnListParams;
        } catch (error) {
            return rejectWithValue(getApiErrorMessage(error));
        }
    }
);

export const getColumnListSlice = createSlice({
    name: "GET_GENE_COLUMN_LIST",
    initialState,
    reducers: {
        clearResponse: (state) => {
            state.response = null;
            state.message = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGeneColumnListAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(getGeneColumnListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                state.message = null;
            })
            .addCase(getGeneColumnListAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload ?? "Unknown error";
                state.response = null;
            });
    },
});

export const { clearResponse } = getColumnListSlice.actions;
export default getColumnListSlice.reducer;